// extracted by mini-css-extract-plugin
module.exports = {"Drawer":"Drawer_Drawer__4THpm","content":"Drawer_content__1zlWc","drnavdiv":"Drawer_drnavdiv__10ee6","open":"Drawer_open__3ndxu","close":"Drawer_close__3YBiI"};